<template>
  <div class="message-view-container">
    <el-card class="page-header-card" shadow="hover">
      <div class="page-header">
        <div class="page-title-section">
          <h2 class="page-title">
            <font-awesome-icon icon="envelope" class="page-title-icon" />
            Мессеж удирдах хэсэг
          </h2>
          <p class="page-subtitle">Мессеж загвар үүсгэх, илгээх</p>
        </div>
        <div class="header-actions">
          <el-button
            @click="createMessageDialogOpen()"
            type="primary"
            size="large"
            class="action-button"
          >
            <font-awesome-icon icon="plus" class="button-icon" />
            Мессеж загвар үүсгэх
          </el-button>
          <el-button
            @click="sendMessageDialogOpen()"
            type="success"
            size="large"
            class="action-button"
          >
            <font-awesome-icon icon="paper-plane" class="button-icon" />
            Мессеж илгээх
          </el-button>
        </div>
      </div>
    </el-card>

    <el-card class="table-card mt-10" shadow="hover">
      <template #header>
        <div class="table-header">
          <font-awesome-icon icon="table" class="table-header-icon" />
          <span class="table-header-title">Мессеж загварын жагсаалт</span>
          <el-tag type="info" class="table-count-tag" v-if="messageList">{{ messageList.length }} загвар</el-tag>
        </div>
      </template>
      <el-table :data="messageList" class="modern-message-table" stripe>
            <el-table-column label="№" type="index"></el-table-column>
            <el-table-column label="Гарчиг" prop="title"></el-table-column>
            <el-table-column label="Текст" prop="sms_text"></el-table-column>
            <el-table-column label="Үйлдэл" width="300" align="center">
              <template v-slot="scope">
                <el-button-group>
                  <el-button
                    type="success"
                    @click="sendMessageDialogOpen(scope.row)"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="paper-plane" class="button-icon-small" />
                    Илгээх
                  </el-button>
                  <el-button
                    type="warning"
                    @click="createMessageDialogOpen(scope.row)"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="edit" class="button-icon-small" />
                    Засварлах
                  </el-button>
                  <el-button
                    type="primary"
                    @click="customMessageDialogOpen(scope.row)"
                    v-if="scope.row.query"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="list" class="button-icon-small" />
                    Жагсаалт
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
    </el-card>
      <SendMessageDialog :selectedMessage="this.targetMessage"/>
      <CreateMessageDialog :selectedMessage="this.targetMessage" @refreshList="loadData"/>
      <CustomMessageDialog :selectedMessage="this.targetMessage" :query="this.queryResult"/>
    </div>
  </template>
<script>
import services from '@/services'
import SendMessageDialog from './sendMessageDialog.vue'
import CreateMessageDialog from './createMessageDialog.vue'
import CustomMessageDialog from './customMessageDialog.vue'
import { mapActions, mapGetters } from 'vuex'
import { ElMessage } from 'element-plus'

export default {
  name: 'MessageView',
  data () {
    return {
      messageList: null,
      targetMessage: {
      },
      queryResult: [],
      loadDataList: [],
      total_count: null,
      trackCodeCOunt: 0,
      phone: null
    }
  },
  components: {
    SendMessageDialog,
    CreateMessageDialog,
    CustomMessageDialog
  },
  computed: {
    ...mapGetters([
      'cdnGetter'
    ])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions(['setCreateMessageDialog', 'setSendMessageDialog', 'setCustomMessageDialog']),
    sendMessageDialogOpen (data) {
      this.targetMessage = data
      this.setSendMessageDialog({ visible: true })
    },
    createMessageDialogOpen (data) {
      this.targetMessage = data
      this.setCreateMessageDialog({ visible: true })
      this.loadData()
    },
    customMessageDialogOpen (data) {
      this.targetMessage = data
      this.setCustomMessageDialog({ visible: true })
    },
    async getPhones (data) {
      this.$root.fullscreenLoading = true
      this.targetMessage = data
      const payload = { custom_day: data.query }
      try {
        const response = await services.create('getPhoneList', payload)
        if (response) {
          this.$root.fullscreenLoading = false
          this.queryResult = response.data
          this.customMessageDialogOpen(response.data)
        } else {
          this.$root.fullscreenLoading = false
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        this.$root.fullscreenLoading = false
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    },
    async loadData () {
      try {
        const response = await services.get('message')
        if (response) {
          this.messageList = response.data
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
/* Message View Container */
.message-view-container {
  padding: 0;
}

/* Page Header Card */
.page-header-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title-section {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title-icon {
  color: #667eea;
  font-size: 32px;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.action-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.action-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.button-icon {
  margin-right: 8px;
}

/* Table Card */
.table-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-header-icon {
  color: #667eea;
  font-size: 20px;
}

.table-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.table-count-tag {
  border-radius: 20px;
  padding: 4px 12px;
}

/* Modern Message Table */
.modern-message-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-message-table :deep(.el-table__header) {
  background: #f9fafb;
}

.modern-message-table :deep(.el-table__header th) {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding: 16px 0;
}

.modern-message-table :deep(.el-table__body tr:hover) {
  background: #f3f4f6;
}

.modern-message-table :deep(.el-table__body td) {
  padding: 16px 0;
}

/* Action Buttons */
.action-button {
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
}

.button-icon-small {
  margin-right: 4px;
  font-size: 12px;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  .header-actions {
    width: 100%;
    flex-direction: column;
  }

  .action-button {
    width: 100%;
    margin-bottom: 8px;
    font-size: 11px;
    padding: 6px 8px;
  }

  .button-icon-small {
    display: none;
  }

  /* Mobile Table Scroll */
  .table-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modern-message-table {
    min-width: 600px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .action-button {
    font-size: 10px;
    padding: 8px 12px;
  }
}
</style>
